export default __webpack_public_path__ + "static/media/Redo.45a80270.svg";